// extracted by mini-css-extract-plugin
module.exports = {"circle":"styles_circle__4SsDl","badge":"styles_badge___9ZXu"};